import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { Observable } from 'rxjs';
import { GenreWithPagination } from '@shared/interfacres/genre';
import { BaseApiService } from '@data-access/common/base-api.service';

@Injectable({providedIn: 'root'})
export class GenreManagerService extends BaseApiService {


  getFilteredList(
    name: string,
    filter: GetFilter,
    pagination: GetPagination
  ): Observable<GenreWithPagination> {

    let apiUrl = `${this.apiUrl}/admin/settings/genres/paginated?page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${filter.query}&sortDirection=${filter.order}`;
    if (name) {
      apiUrl += `&search=${name}`;
    }
    return this._httpClient.get<GenreWithPagination>(apiUrl).pipe(
      map((response: GenreWithPagination) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }


  getList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/genres`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  create(name: string) {
    const url = `${this.apiUrl}/admin/settings/genres`;
    return this._httpClient.post(url, {name}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  update(id: number, name: string) {
    const url = `${this.apiUrl}/admin/settings/genres/${id}`;
    return this._httpClient.patch(url, {name}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  delete(ids: number[]) {
    const url = `${this.apiUrl}/admin/settings/genres`;
    return this._httpClient.delete(url, {body: {ids}}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

}
